import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Flex, Box } from 'roo-ui/components';
import get from 'lodash/get';
import {
  getPointsAmount,
  getVoucherAmount,
  getPayableNowCashAmount,
  getPayableLaterCashAmount,
  getTravelPassAmount,
} from 'store/checkout/checkoutSelectors';
import { getPayableLaterDueDate } from 'store/quote/quoteSelectors';
import PaymentBreakdown from 'components/PaymentBreakdown';
import PriceBreakdownModal from 'pages/Checkout/PriceBreakdownModal';
import Currency from 'components/Currency';

const PriceDetails = ({ property, offer, checkIn, checkOut, ...rest }) => {
  const { charges } = offer;
  const payableAtProperty = get(charges, 'payableAtProperty.total');
  const voucherAmount = useSelector(getVoucherAmount);
  const pointsAmount = useSelector(getPointsAmount);
  const travelPassAmount = useSelector(getTravelPassAmount);
  const payableNowCashAmount = useSelector(getPayableNowCashAmount);
  const payableLaterCashAmount = useSelector(getPayableLaterCashAmount);
  const payableLaterDueDate = useSelector(getPayableLaterDueDate);

  return (
    <Box {...rest}>
      {!voucherAmount.isZero() && (
        <Flex pb={[2, 3]} mb={[3, 6]} borderBottom={1} borderColor="greys.alto" justifyContent="space-between">
          <Box flex={['0 0 170px', '0 0 200px']} fontSize={['sm', 'base']}>
            Voucher
          </Box>
          <Currency amount={voucherAmount.negated()} currency="AUD" fontSize={['sm', 'base']} data-testid="voucher-amount" />
        </Flex>
      )}
      <PaymentBreakdown
        payableNowCashAmount={payableNowCashAmount}
        payableLaterCashAmount={payableLaterCashAmount}
        payableLaterDueDate={payableLaterDueDate}
        pointsAmount={pointsAmount}
        travelPassAmount={travelPassAmount}
        payableAtProperty={payableAtProperty}
      />
      <PriceBreakdownModal property={property} offer={offer} checkIn={checkIn} checkOut={checkOut} />
    </Box>
  );
};

PriceDetails.propTypes = {
  property: PropTypes.shape({
    name: PropTypes.string,
  }),
  offer: PropTypes.shape({
    charges: PropTypes.object,
    type: PropTypes.string,
  }),
  checkIn: PropTypes.instanceOf(Date).isRequired,
  checkOut: PropTypes.instanceOf(Date).isRequired,
};

PriceDetails.defaultProps = {
  property: { name: undefined },
  offer: { charges: {}, type: undefined },
};

export default PriceDetails;
